import styled from 'styled-components';

export const RoutineBaseFormWrapper = styled.div<{ border?: boolean }>`
  width: 65%;
  padding: 0 32px 30px 0;
  margin: 0 32px 30px 12px;
  border-right: ${(props) =>
    props.border
      ? `1px solid ${props.theme.palette.background.default}`
      : 'none'};

  ${({ theme }) => theme.breakpoints.down('lg')} {
    max-width: 552px;
    width: 100%;
    border: none;
    padding: 0;
    margin: 0;
  }
`;
